/* eslint-disable */ 
import React, { useState ,useEffect} from "react";
import { logo } from "../_components/Imagepath";
import axios from "axios";
import { useTranslation } from "react-i18next";
import Lang from "../common/Lang";
const VerificationAdmin = (props) => {
    const { t } = useTranslation();
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get('id');
        const token = urlParams.get('token');

        const data = {"id": id, "token": token};

        const confirmAccount = async () => {
            try {
                const response = await axios.post(process.env.REACT_APP_BASE_URL+"/auth/account-confirmation/", data);
                
                // Handle the HTML response (success or failure message)
                if (response.data.success) {
                    document.getElementById('verification-result').innerHTML = `
                        <h5 style='color:green;'>${t("Verification Successful")}</h5>
                        <br>
                        <p>${t("Your account is now verified.")}</p>
                        <p><a href="https://crm.kflow.cloud/login">${t("Go to Login Page")}</a></p>
                    `;
                    setTimeout(() => {
                        window.location.href = "https://crm.kflow.cloud/login"; // Redirect to login page after 5 seconds
                    }
                    , 1500);
                } else {
                    document.getElementById('verification-result').innerHTML = "<h5 style='color:red;'>"+t("Verification Failed")+"</h5><br><p>"+t("The link is invalid or expired.")+"</p>";
                }

              
            } catch (error) {
                console.error('Error confirming account:', error);
                document.getElementById('verification-result').innerHTML = "<h5 style='color:red;'>"+t("Error during verification.")+"</h5>";
            }
        };
        
        confirmAccount();
    }, []);

  return (
    <>
      <div className="main-wrapper login-body">
        <div className="login-wrapper">
          <div className="container">
            <img
              className="img-fluid logo-dark mb-2"
              src={logo}
              alt="Logo"
            />
            <div className="loginbox">
              <div className="login-right">
                <div className="login-right-wrap">
                    <div className="text-center">
                        <div id="verification-result"></div> {/* This will display the result from the backend */}
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default VerificationAdmin;